import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m20.12 8.72-5.1 5.11-5.11-5.11-5.1 5.11 2.55 2.55 2.55-2.55 5.11 5.1 7.66-7.65 2.55 2.55V6.17h-7.66z" }, null, -1),
    _createElementVNode("path", { d: "m7.48 18.92-1.01-1-1.23-1.24v9.01h4.72v-9.25l-1.48 1.48zM22.8 13.82l-2.56 2.55v9.32h4.72v-9.71l-.62-.61zM15.14 21.48l-1.01-1.01-1.37-1.37v6.59h4.72v-6.56l-1.34 1.34z" }, null, -1)
  ])))
}
export default { render };